import { Icons } from '@ohif/ui-next';

/** Adds the icon to both ui and ui-next */
export function addIcon(name, icon) {
  Icons.addIcon(name, icon);
}
